/**
 * @description Hook utilizado para manipular os erros
 * @author Diego Sabino Amorim de Araújo
 * @file useErrorService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useDispatch } from 'react-redux'
import useRouter from 'utils/useRouter'
import { criarAlerta } from 'actions'

export const useErrorService = () => {
  const router = useRouter()
  const dispatch = useDispatch()

  const redirectLogout = () => {
    dispatch({
      type: 'SESSION_LOGOUT_TOKEN_EXPIRADO_SUCESSO',
    })
    localStorage.removeItem('@sigep/token')
    localStorage.removeItem('@sigep/state')

    if (router) {
      router.history.push(`/auth/login`)
    }
  }

  const tratarErro = async (err) => {
    if (err.response) {
      if (err.response.status === 401) {
        redirectLogout(err)
        dispatch(criarAlerta(err.response, router))
      } else {
        dispatch(criarAlerta(err.response, router))
      }
    } else {
      dispatch(criarAlerta(err, router))
    }
  }

  return {
    tratarErro,
  }
}
